const { isNative } = require('~global/screens');

const { ADJUST_ENV, ADJUST_APP_TOKEN, ADJUST_LOGGING } =
  require('~config/default.env').default;

const isAdjustProd = ADJUST_ENV === 'production';
const appAdjustToken = ADJUST_APP_TOKEN;

let AdjustConfig;
let envAdjust;
let logLevelAdjust;
let webAdjustToken;

if (isNative) {
  const { AdjustConfig: NativeAdjustConfig } = require('react-native-adjust');
  AdjustConfig = NativeAdjustConfig;

  envAdjust = isAdjustProd
    ? AdjustConfig.EnvironmentProduction
    : AdjustConfig.EnvironmentSandbox;
  logLevelAdjust = isAdjustProd
    ? AdjustConfig.LogLevelInfo
    : AdjustConfig.LogLevelVerbose;
} else {
  envAdjust = ADJUST_ENV || 'sandbox';
  logLevelAdjust = isAdjustProd ? 'error' : 'verbose';
}

const isDebugAdjust = ADJUST_LOGGING || false;

let eventTokens;
let linkTokens;

if (isAdjustProd) {
  eventTokens = {
    add_to_cart: 'ko7ggg',
    add_to_wishlist: 'r52uuo',
    complete_registration: 'toggo1',
    login: '7lo4b5',
    page_view: 'js1bl1',
    purchase: '1k4mzn',
    search: 'cdvqci',
    view_product: 'i2tn9c',
    lilla_short_link_resolved: 'jruqi3',
    direct_deep_link: 'tcr73n',
    deferred_deep_link: 'evp8zr',
  };

  linkTokens = '1qtt6w8y';
  webAdjustToken = 're5xj577tzwg';
} else {
  eventTokens = {
    add_to_cart: 'fpheda',
    add_to_wishlist: '78uyb9',
    complete_registration: 'w4hkdk',
    login: 'do7l76',
    page_view: 'tyhj7n',
    purchase: 'mcqfxi',
    search: 'npr9f7',
    view_product: 'nms8ad',
    lilla_short_link_resolved: 'pk3epw',
    direct_deep_link: 'xlnmf0',
    deferred_deep_link: 'g5qmll',
  };

  linkTokens = '1quzm6rp';
  webAdjustToken = '16putujfwvpc';
}

/**
 * Formats the deep link path for iOS and Android.
 * @param {Object} params - The parameters for the deep link path.
 * @param {string} params.parent - The parent path. (required)
 * @param {string} [params.child] - The child path. (optional)
 * @param {string} [params.custom] - The custom query parameters. (optional)
 * @returns {Object} An object containing formatted deep link paths for iOS and Android.
 * @throws {Error} If the parameters are invalid.
 * @example
 * const deepLinkPaths = formattedDeepLinkPath({
 *   parent: 'bd',
 *   child: '15760_boonaboo',
 *   custom: 'tab=Home',
 * });
 */
const formattedDeepLinkPath = (params) => {
  if (!params || !params.parent) {
    throw new Error(
      'Invalid parameters for deep link path: parent is required',
    );
  }
  let path = params.parent;
  if (params.child) {
    path += `/${params.child}`;
  }
  if (params.custom) {
    path += `?${params.custom}`;
  }
  return {
    ios_deep_link_path: path,
    android_deep_link_path: path,
  };
};

module.exports = {
  isAdjustProd,
  appAdjustToken,
  webAdjustToken,
  envAdjust,
  logLevelAdjust,
  isDebugAdjust,
  eventTokens,
  linkTokens,
  formattedDeepLinkPath,
};
